export const emptyAnalytics = {
  templateId: "",
};
